export const emptyAnalytics = {
  templateId: "",
};
